import PriceList from 'components/common/helpers/PriceList';

class BookingReducerHelper {
  constructor(state) {
    this.state = state;
    this.priceList = null;
    return this;
  }

  totalPassengers() {
    var s = this.state;
    return s.adultsNumber + s.childrenNumber + s.seniorsNumber + s.studentsNumber + s.teenagersNumber;
  }

  setPriceList(priceList) {
    this.priceList = priceList;
    return this;
  }

  phoneHasChanged(newState) {
    return this.state.userData.phone !== newState.userData.phone ||
      this.state.userData.phoneCountry.label !== newState.userData.phoneCountry.label;
  }

  getDeparturePrice() {
    return this.getPriceForAddressObject(this.state.departureAddress, this.priceList);
  }

  getReturnPrice() {
    if (this.state.returnFlight) {
      if (this.state.differentReturnAddress) {
        return this.getPriceForAddressObject(this.state.returnAddress, this.priceList);
      } else {
        return this.getDeparturePrice();
      }
    }
    return 0;
  }

  getPriceForAddressObject(addressObject) {
    var selectedObject = addressObject.selectedObject;
    if (!selectedObject) {
      return 0;
    }

    if (selectedObject.g) {
      var busStopName = null;
      var postcode = addressObject.postcode;
    } else {
      var busStopName = selectedObject.value;
      var postcode = null;
    }
    var adults = this.state.adultsNumber;
    var children = this.state.childrenNumber;
    var seniors = this.state.seniorsNumber;
    var students = this.state.studentsNumber;
    var teenagers = this.state.teenagersNumber;
    var stateParams = {
      busStopName,
      postcode,
      adults,
      children,
      seniors,
      teenagers,
      students
    };
    var priceParams = _.merge({}, stateParams);
    return new PriceList(this.priceList).getTotalPrice(priceParams);
  }
}

export default BookingReducerHelper;
